module.exports = __webpack_public_path__ + "img/3.b7cac0a2.jpg";